import type { Logger } from '~/shared/interfaces'

export interface CreateLoggerOptions {
  scope: string
  captureException?: (error: unknown) => void
}

export const createLogger = ({ scope, captureException }: CreateLoggerOptions): Logger => {
  const prefix = (message: string): string => `[${scope}] ${message}`

  return {
    warn(message, error) {
      if (error === undefined) {
        console.warn(prefix(message))
        return
      }

      console.warn(prefix(message), error)
    },

    error(message, error) {
      if (error === undefined) {
        console.error(prefix(message))
      }
      else {
        console.error(prefix(message), error)
      }

      captureException?.(error ?? new Error(prefix(message)))
    },
  }
}
